import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BuyerAccountInformation } from '@arc/unified-payments-frontend/shared-payment';

export const PoaPadResultComponentPayInfoActions = createActionGroup({
  source: 'Pad Result Component Pay Info',
  events: {
    'Get Buyer Accounts Success': props<{
      buyerAccounts: BuyerAccountInformation[];
    }>(),
    'Get Buyer Accounts Error': emptyProps(),
  },
});
